import {AsyncActionState} from '../../standard-actions/async-action'

// Status values from downstream
export const SERVICE_STATUS_OPTIMAL = 'Optimal'
export const SERVICE_STATUS_DEGRADED = 'Degraded'
export const SERVICE_STATUS_ISSUES = 'Issues'
export const SERVICE_STATUS_ACTIVE = 'Active' // This status comes from API for DYNAMIC DEVICE TYPE and also used to map OPTIMAL Status to Active on Frontend services List
export const SERVICE_STATUS_INTERMITTENT = 'Intermittent'
export const SERVICE_STATUS_IDLE = 'Idle'
export const SERVICE_STATUS_NO_DATA = 'No Data'
export const SERVICE_STATUS_NA = 'N/A'

// Below Status mapped to frontend based on the above statuses
export const SERVICE_STATUS_OFFLINE_UNREACHABLE = 'Offline / unreachable'
export const SERVICE_STATUS_PARTIALLY_ACTIVE_INTERMITTENT = 'Partially active / intermittent'
export const SERVICE_STATUS_NO_DATA_AVAILABLE = 'No data available'
export const SERVICE_STATUS_EMPTY = ''
export const SERVICE_STATUS_PLANNED_MAINTENANCE = 'Planned maintenance'
/*
  we usually get the following statuses for these devicetypes
  for DEVICE TYPE - FIXED:
    status are OPTIMAL, DEGRADED, ISSUES, NO_DATA
  for DEVICE TYPE - DYNAMIC
    status are ACTIVE, INTERMITTENT, ISSUES, NO_DATA

  'n/a' Status is shown when the downstream is not sending any status value from the above
  and hence is controlled at the frontend.


  Until Now, these status were used to determine which icon to be shown on the list page along side mertic or text values.
  But going forward the metric information ( which was shown for FIXED Services )
  will be completely changed to text based values mentioned below hanlded at the frontend based on the above status values.

  Since, Dynamic Device Types used to show Text based only right from start hence it is untouched and only FIXED is changed

  Mapping between the above managed at backend with below mentioned frontend is given in STATUS_MAPPING

  OFFLINE_UNREACHABLE
  PARTIALLY_ACTIVE_INTERMITTENT
  ACTIVE
*/

export type IServiceStatus =
  | typeof SERVICE_STATUS_OPTIMAL
  | typeof SERVICE_STATUS_DEGRADED
  | typeof SERVICE_STATUS_ISSUES
  | typeof SERVICE_STATUS_ACTIVE
  | typeof SERVICE_STATUS_INTERMITTENT
  | typeof SERVICE_STATUS_IDLE
  | typeof SERVICE_STATUS_NO_DATA
  | typeof SERVICE_STATUS_NA
  | typeof SERVICE_STATUS_OFFLINE_UNREACHABLE
  | typeof SERVICE_STATUS_PARTIALLY_ACTIVE_INTERMITTENT
  | typeof SERVICE_STATUS_EMPTY
  | typeof SERVICE_STATUS_PLANNED_MAINTENANCE

export const serviceStatuses: IServiceStatus[] = [
  SERVICE_STATUS_OPTIMAL,
  SERVICE_STATUS_ISSUES,
  SERVICE_STATUS_DEGRADED,
  SERVICE_STATUS_ACTIVE,
  SERVICE_STATUS_INTERMITTENT,
  SERVICE_STATUS_IDLE,
]

export const newServiceStatuses: IServiceStatus[] = [
  SERVICE_STATUS_OFFLINE_UNREACHABLE,
  SERVICE_STATUS_PARTIALLY_ACTIVE_INTERMITTENT,
  SERVICE_STATUS_IDLE,
  SERVICE_STATUS_ACTIVE,
]

export const DEVICE_TYPE_DYNAMIC = 'dynamic'
export const DEVICE_TYPE_FIXED = 'fixed'
export type IDeviceType = typeof DEVICE_TYPE_FIXED | typeof DEVICE_TYPE_DYNAMIC

export interface IService {
  serviceId: string
  productName: string
  serviceType: string
  deviceType: IDeviceType
  deviceName?: string
  location?: string
  userReference?: string
  groupName?: string
  availability?: number
  utilisation?: number
  errors?: number
  recordType?: 'device' | 'interface'
  activityStatus?: IServiceStatus // only when deviceType === 'dynamic'
  availabilityStatus?: IServiceStatus // only when deviceType === 'fixed'
  deviceStatus?: IServiceStatus // only for SDWAN router which is also sometimes called as device which is distinguished based on recordType === 'device'
  interfaceStatus?: IServiceStatus // only for SDWAN interface which is distinguised when recordType === 'interface'
  utilisationStatus?: IServiceStatus
  errorsStatus?: IServiceStatus
  header?: boolean
  incident?: string
  hasPm?: boolean
  serviceFnn?: string
  siteId: string
  // below will come only when it is a SDWAN device/interface
  numberOfInterfaces?: number
  productCategory?: 'SDWAN'
  utilisationIn?: string
  utilisationOut?: string
  interfaces?: IService[]
}

export interface IServicesResponse {
  services: IService[]
  hasServiceTypes: IDeviceType[]
  numberOfServices: number
  refreshInterval: number
  stateId: string
  searchTermsCharacterLimit: number
  lastPolledTime?: string
  lastPolledDateTime?: string
  enableIncident: boolean
  hasPlannedMaintenance?: boolean
  customerId: string
}

export interface ILoadServicesRequest {
  data: IServicesResponse
  status: AsyncActionState
  error?: string
}
